<template>
	<div class="mainConent">
		<p class="title"><el-button icon="el-icon-circle-plus-outline" type="primary" @click="dialogType = true">添加</el-button></p>
		<el-table :data="tableData" border style="width: 100%">
			<el-table-column prop="id" label="id"></el-table-column>
			<el-table-column prop="name" label="类型"></el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button size="mini" type="warning" icon="el-icon-edit-outline" @click="handleEdit(scope.row)">编辑</el-button>
					<el-button size="mini" type="danger" icon="el-icon-circle-close" @click="handleDelete(scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="pageBlock">
			<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="currentPage"
				:page-sizes="[5, 10, 15, 20]"
				:page-size="100"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total"
			></el-pagination>
		</div>
		<el-dialog title="添加新闻" :visible.sync="dialogType">
			<el-form :model="addForm">
				<el-form-item label="新闻类型"><el-input v-model="addForm.name" autocomplete="off"></el-input></el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogType = false">取 消</el-button>
				<el-button type="primary" @click="addType">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="编辑新闻" :visible.sync="edit_type">
			<el-form :model="editForm">
				<el-form-item label="新闻类型"><el-input v-model="editForm.name" autocomplete="off"></el-input></el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="edit_type = false">取 消</el-button>
				<el-button type="primary" @click="editType">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			edit_type: false,
			total: 0,
			pageSize: 5,
			currentPage: 1,
			dialogType: false,
			addForm: {
				name: ''
			},
			editForm: {
				name: '',
				id: ''
			},
			tableData: []
		};
	},
	created() {
		this.getType();
	},
	methods: {
		handleSizeChange(val) {
			//获取每页条数
			this.pageSize = val;
			this.getType();
		},
		handleCurrentChange(psize) {
			//当前页
			this.currentPage = psize;
			this.getType();
		},

		getType() {
			//新闻类型列表
			let data = {
				pageNum: this.currentPage,
				pageSize: this.pageSize
			};
			this.$get('type/list', data).then(res => {
				this.tableData = res.list;
				this.total = res.total;
			});
		},
		addType() {
			//添加类型
			// this.dialogType=false
			let data = new FormData();
			data.append('name', this.addForm.name);
			this.$post('type/add', data).then(res => {
				this.getType();
				this.dialogType = false;
			});
		},
		handleEdit(row) {
			//获取编辑详情
			this.edit_type = true;
			let data = {
				id: row.id
			};
			this.$get('type/update', data).then(res => {
				this.editForm.name = res.name;
				this.editForm.id = res.id;
			});
		},
		editType() {
			//编辑确定
			let data = new FormData();
			data.append('name', this.editForm.name);
			data.append('id', this.editForm.id);
			this.$post('type/save', data).then(res => {
				this.$message({
					type: 'success',
					message: '编辑成功!'
				});
				this.edit_type = false;
				this.getType();
			});
		},
		handleDelete(row) {
			this.$confirm('是否删除?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					let data = new FormData();
					data.append('id', row.id);
					this.$post('type/del', data).then(res => {
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
						this.getType();
					});
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
		}
	}
};
</script>

<style>
.mainConent .title {
	margin-bottom: 10px;
}
.mainConent .cell {
	text-align: center !important;
}
.mainConent .pageBlock {
	margin-top: 10px;
	text-align: center;
}
</style>
